/**
 * Pure helpers for Connect resume Accept/Decline enablement (Phase 3.1H-2).
 */

export type ConnectResumeActionItem = {
  availableActions: string[]
  eligibleDogIds?: string[]
  blockReason?: 'SELF_CONNECTION' | null
  senderDog?: { name?: string | null }
}

export function canActOnConnectResume(
  item: ConnectResumeActionItem | null | undefined,
  selectedDogId: string | null | undefined
): boolean {
  if (!item || item.blockReason === 'SELF_CONNECTION') return false
  if (!selectedDogId) return false
  if (
    Array.isArray(item.eligibleDogIds) &&
    item.eligibleDogIds.length > 0 &&
    !item.eligibleDogIds.includes(selectedDogId)
  ) {
    return false
  }
  return (
    item.availableActions.includes('ACCEPT') &&
    item.availableActions.includes('DECLINE')
  )
}

export function connectResumeSelfConnectionMessage(senderDogName?: string | null): string {
  const name = senderDogName?.trim()
  if (name) {
    return `You can’t connect ${name} to the same account. Open this invitation using another dog parent’s Wagamour account.`
  }
  return 'You can’t connect this invitation to the same account. Open it using another dog parent’s Wagamour account.'
}
